// importing images
import authentic from "./images/authentic.svg";
import family from "./images/family.svg";
import fast from "./images/fast_delivery.svg";
import value from "./images/best_value.svg";
import featureImage1 from "./images/feature_1.svg";
import featureImage2 from "./images/feature_2.svg";
import featureImage3 from "./images/feature_3.svg";
import featureImage4 from "./images/feature_4.svg";
import featureImage5 from "./images/feature_5.svg";

const features = [
  {
    title: "100% Authentic",
    image: authentic,
  },
  {
    title: "Desi Family Card",
    image: family,
  },
  {
    title: "Fast Delivery",
    image: fast,
  },
  {
    title: "Best Value Guarantee",
    image: value,
  },
];

const featureData = [
  {
    image: featureImage1,
    title: "Authenticity Check",
  },
  {
    image: featureImage2,
    title: "Return Policy",
  },
  {
    image: featureImage3,
    title: "100% Secure Payment",
  },
  {
    image: featureImage4,
    title: "Dedicated Customer Support",
  },
  {
    image: featureImage5,
    title: "Discounts & Offers",
  },
];

export { features, featureData };
